(function () {
  'use strict';

  // Quick-add: POST to /cart/add.js, then ask the theme's existing
  // cart.js to refresh the drawer sections and open it — reuses the
  // exact same "cart:refresh" event the rest of the theme relies on.
  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-quick-add-variant]');
    if (!button) return;

    event.preventDefault();
    if (button.classList.contains('is-loading')) return;

    const variantId = button.dataset.quickAddVariant;
    button.classList.add('is-loading');

    fetch(`${window.MinimogSettings?.routes?.cart_add_url || '/cart/add.js'}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status) {
          console.error('Quick add error:', data.description || data.message);
          return;
        }
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
      })
      .catch((error) => {
        console.error('Quick add error:', error);
      })
      .finally(() => {
        button.classList.remove('is-loading');
      });
  });

  // Complete the Look carousel arrows
  document.addEventListener('click', function (event) {
    const prevButton = event.target.closest('[data-look-prev]');
    const nextButton = event.target.closest('[data-look-next]');
    if (!prevButton && !nextButton) return;

    const wrapper = (prevButton || nextButton).closest('.m-cart-drawer__complete-look');
    const track = wrapper && wrapper.querySelector('[data-look-track]');
    if (!track) return;

    const firstCard = track.querySelector('.m-cart-drawer__complete-look-card');
    const scrollAmount = firstCard ? firstCard.getBoundingClientRect().width + 12 : 160;

    track.scrollBy({
      left: prevButton ? -scrollAmount : scrollAmount,
      behavior: 'smooth',
    });
  });
})();